export const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
  {
    languageId: 'chinese',
    locale: 'zh',
    name: 'Chinese',
    icon: 'cn',
  },
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Spanish',
    icon: 'es',
  },
  {
    languageId: 'french',
    locale: 'fr',
    name: 'French',
    icon: 'fr',
  },
  {
    languageId: 'italian',
    locale: 'it',
    name: 'Italian',
    icon: 'it',
  },
  {
    languageId: 'saudi-arabia',
    locale: 'ar',
    name: 'Arabic',
    icon: 'sa',
  },
];

export const flags = {
  en: 'http://sanchan-ott-resources.imgix.net/common/ottadmin/images/flag/icons8-usa.png',
  zh: 'http://sanchan-ott-resources.imgix.net/common/ottadmin/images/flag/icons8-china.png',
  es: 'http://sanchan-ott-resources.imgix.net/common/ottadmin/images/flag/icons8-spain.png',
  fr: 'http://sanchan-ott-resources.imgix.net/common/ottadmin/images/flag/icons8-france.png',
  it: 'http://sanchan-ott-resources.imgix.net/common/ottadmin/images/flag/icons8-italy.png',
  ar: 'http://sanchan-ott-resources.imgix.net/common/ottadmin/images/flag/icons8-saudi_arabia.png',
};
